var $ = require('jquery')
  , Base64 = require('js-base64').Base64
  , rVideoHashId = /\/\/v.17173.com\/.+\/(.*)\.html/
  , rVideoHashIdSohu = /\/\/17173.tv.sohu.com\/.+\/(.*)\.html/
  , tmpl = require('./tmpl.handlebars')

$(function() {
  var modVideo = $('.mod-video')
    , modVideoPlayer = $('.mod-video-player')

  if (!modVideo.length) { return }

  var src = modVideo.data('src')
    , sthml
    , matched = src.match(rVideoHashId) || src.match(rVideoHashIdSohu)

  if (!matched || matched.length < 1) { return }

  hashId = Base64.decode(matched[1])

  shtml = tmpl({
    poster: modVideo.data('poster')
  , videoUrl: '//v.17173.com/api/' + hashId + '-1.m3u8'
  })

  modVideo.html(shtml)

  var video = modVideo.find('video')
    , ratio = 607 / 345

  // 视频尺寸 607 * 333

  video.height(video.width() / ratio)
})
